import React from 'react';
import PropTypes from 'prop-types';
import { FilterSection } from './filter_section';
import { FilterCheckbox } from './filters/filter_checkbox';
import { Filters } from '../../../../constants/filter/filters';
import { FilterLabelTranslationKeys } from '../../../../constants/filter/filter_label_translation_keys';
import TranslationContainer from '../../../translation/translation_container';

function Deals(props) {
    const existingPromotion = props.buy4Pay3Value || props.clearanceValue;// || props.instantCashValue;
    const newPromotion = props.discountInstantCash50Value ||
        props.discountInstantCash80Value ||
        props.discountInstantCash100Value ||
        props.discountInstantCash120Value ||
        props.discountInstantCash150Value ||
        props.discountInstantCash160Value ||
        props.discountInstantCash200Value ||
        props.discountInstantCash250Value ||
        props.discountInstantCash300Value ||
        props.discount5OffValue ||
        props.discount10OffValue ||
        props.discount15OffValue ||
        props.discount20OffValue ||
        props.discount25OffValue ||
        props.promoGiftCard50Value ||
        props.promoGiftCard80Value ||
        props.promoGiftCard100Value ||
        props.promoGiftCard130Value ||
        props.promoGiftCard150Value ||
        props.promoGiftCard200Value ||
        props.promoGiftCard250Value ||
        props.freeFittingValue;

    const opened = props.opened || existingPromotion || newPromotion;
    return (
        <FilterSection
            opened={opened}
            resettable={props.resettable}
            onActionClick={props.onActionClick}
            headline='catalog-filters-section-headline-deals'
            containerModifier="deals"
            scrollable={true}
        >
            {props.freeFittingEnabled &&
                <TranslationContainer targetProperties={{
                    tooltipContent: {
                        translationKey: props.freeFittingEnabled ?
                            'catalog-filters-free-fitting-tooltip' :
                            'catalog-filters-conditional-option-disabled'
                    }
                }}>
                    <FilterCheckbox
                        name={Filters.FREE_FITTING}
                        checked={props.freeFittingValue}
                        labelTranslationKey={FilterLabelTranslationKeys[Filters.FREE_FITTING]}
                        tooltipContent="will-be-replace"
                        onChange={props.onFreeFittingChange}
                        onToolTipHover={() => props.onToolTipHover('Free Fitting')}
                        disabled={!props.freeFittingEnabled}
                    />
                </TranslationContainer>
            }
            <TranslationContainer targetProperties={{
                tooltipContent: {
                        translationKey: props.buy4Pay3Enabled ?
                        'catalog-filters-buy-4-for-3-tooltip' :
                        'catalog-filters-conditional-option-disabled'
                }
            }}>
                <FilterCheckbox
                    name={Filters.BUY_4_PAY_3}
                    checked={props.buy4Pay3Value}
                    labelTranslationKey={FilterLabelTranslationKeys[Filters.BUY_4_PAY_3]}
                    tooltipContent="will-be-replace"
                    onChange={props.onBuy4Pay3Change}
                    onToolTipHover={() => props.onToolTipHover('Buy 4 Pay 3')}
                    disabled={!props.buy4Pay3Enabled}
                />
            </TranslationContainer>

            <TranslationContainer targetProperties={{
                tooltipContent: {
                    translationKey: props.clearanceEnabled ?
                        'catalog-filters-clearance-tooltip' :
                        'catalog-filters-conditional-option-disabled'
                }
            }}>
                <FilterCheckbox
                    name={Filters.CLEARANCE}
                    checked={props.clearanceValue}
                    labelTranslationKey={FilterLabelTranslationKeys[Filters.CLEARANCE]}
                    tooltipContent="will-be-replace"
                    onChange={props.onClearanceChange}
                    onToolTipHover={() => props.onToolTipHover('Clearance')}
                    disabled={!props.clearanceEnabled}
                />
            </TranslationContainer>

    {props.discountInstantCash50Enabled &&
    <TranslationContainer targetProperties={{
            tooltipContent: {
                translationKey: props.discountInstantCash50Enabled ?
                    'catalog-filters-instant-cash-50-tooltip' :
                    'catalog-filters-conditional-option-disabled'
            }
        }}>
    <FilterCheckbox
        name={Filters.DISCOUNT_INSTANT_CASH_50}
        checked={props.discountInstantCash50Value}
        labelTranslationKey={FilterLabelTranslationKeys[Filters.DISCOUNT_INSTANT_CASH_50]}
        tooltipContent="will-be-replace"
        onChange={props.onInstantCashChange}
        onToolTipHover={() => props.onToolTipHover('$5 Cashback')}
        disabled={!props.discountInstantCash50Enabled}
        />
        </TranslationContainer>
    }

    {props.discountInstantCash80Enabled &&
    <TranslationContainer targetProperties={{
            tooltipContent: {
                translationKey: props.discountInstantCash80Enabled ?
                    'catalog-filters-instant-cash-80-tooltip' :
                    'catalog-filters-conditional-option-disabled'
            }
        }}>
    <FilterCheckbox
        name={Filters.DISCOUNT_INSTANT_CASH_80}
        checked={props.discountInstantCash80Value}
        labelTranslationKey={FilterLabelTranslationKeys[Filters.DISCOUNT_INSTANT_CASH_80]}
        tooltipContent="will-be-replace"
        onChange={props.onInstantCashChange}
        onToolTipHover={() => props.onToolTipHover('$80 Cashback')}
        disabled={!props.discountInstantCash80Enabled}
        />
        </TranslationContainer>
    }

    {props.discountInstantCash100Enabled &&
        <TranslationContainer targetProperties={{
            tooltipContent: {
            translationKey: props.discountInstantCash100Enabled ?
            'catalog-filters-instant-cash-100-tooltip' :
            'catalog-filters-conditional-option-disabled'
            }
        }}>
            <FilterCheckbox
                name={Filters.DISCOUNT_INSTANT_CASH_100}
                checked={props.discountInstantCash100Value}
                labelTranslationKey={FilterLabelTranslationKeys[Filters.DISCOUNT_INSTANT_CASH_100]}
                tooltipContent="will-be-replace"
                onChange={props.onInstantCashChange}
                onToolTipHover={() => props.onToolTipHover('$100 Cashback')}
                disabled={!props.discountInstantCash100Enabled}
            />
        </TranslationContainer>
    }
    {props.discountInstantCash120Enabled &&
        <TranslationContainer targetProperties={{
            tooltipContent: {
                translationKey: props.discountInstantCash120Enabled ?
                    'catalog-filters-instant-cash-120-tooltip' :
                    'catalog-filters-conditional-option-disabled'
            }
        }}>
            <FilterCheckbox
                name={Filters.DISCOUNT_INSTANT_CASH_120}
                checked={props.discountInstantCash120Value}
                labelTranslationKey={FilterLabelTranslationKeys[Filters.DISCOUNT_INSTANT_CASH_120]}
                tooltipContent="will-be-replace"
                onChange={props.onInstantCashChange}
                onToolTipHover={() => props.onToolTipHover('$120 Cashback')}
                disabled={!props.discountInstantCash120Enabled}
            />
        </TranslationContainer>
    }

    {props.discountInstantCash150Enabled &&
        <TranslationContainer targetProperties={{
            tooltipContent: {
                translationKey: props.discountInstantCash150Enabled ?
                    'catalog-filters-instant-cash-150-tooltip' :
                    'catalog-filters-conditional-option-disabled'
            }
        }}>
            <FilterCheckbox
                name={Filters.DISCOUNT_INSTANT_CASH_150}
                checked={props.discountInstantCash150Value}
                labelTranslationKey={FilterLabelTranslationKeys[Filters.DISCOUNT_INSTANT_CASH_150]}
                tooltipContent="will-be-replace"
                onChange={props.onInstantCashChange}
                onToolTipHover={() => props.onToolTipHover('$150 Cashback')}
                disabled={!props.discountInstantCash150Enabled}
            />
        </TranslationContainer>
    }

    {props.discountInstantCash160Enabled &&
        <TranslationContainer targetProperties={{
            tooltipContent: {
                translationKey: props.discountInstantCash160Enabled ?
                    'catalog-filters-instant-cash-160-tooltip' :
                    'catalog-filters-conditional-option-disabled'
            }
        }}>
            <FilterCheckbox
                name={Filters.DISCOUNT_INSTANT_CASH_160}
                checked={props.discountInstantCash160Value}
                labelTranslationKey={FilterLabelTranslationKeys[Filters.DISCOUNT_INSTANT_CASH_160]}
                tooltipContent="will-be-replace"
                onChange={props.onInstantCashChange}
                onToolTipHover={() => props.onToolTipHover('$160 Cashback')}
                disabled={!props.discountInstantCash160Enabled}
            />
        </TranslationContainer>
    }

    {props.discountInstantCash200Enabled &&
        <TranslationContainer targetProperties={{
            tooltipContent: {
                translationKey: props.discountInstantCash200Enabled ?
                    'catalog-filters-instant-cash-200-tooltip' :
                    'catalog-filters-conditional-option-disabled'
            }
        }}>
            <FilterCheckbox
                name={Filters.DISCOUNT_INSTANT_CASH_200}
                checked={props.discountInstantCash200Value}
                labelTranslationKey={FilterLabelTranslationKeys[Filters.DISCOUNT_INSTANT_CASH_200]}
                tooltipContent="will-be-replace"
                onChange={props.onInstantCashChange}
                onToolTipHover={() => props.onToolTipHover('$200 Cashback')}
                disabled={!props.discountInstantCash200Enabled}
            />
        </TranslationContainer>
    }

    {props.discountInstantCash250Enabled &&
        <TranslationContainer targetProperties={{
            tooltipContent: {
                translationKey: props.discountInstantCash250Enabled ?
                    'catalog-filters-instant-cash-250-tooltip' :
                    'catalog-filters-conditional-option-disabled'
            }
        }}>
            <FilterCheckbox
                name={Filters.DISCOUNT_INSTANT_CASH_250}
                checked={props.discountInstantCash250Value}
                labelTranslationKey={FilterLabelTranslationKeys[Filters.DISCOUNT_INSTANT_CASH_250]}
                tooltipContent="will-be-replace"
                onChange={props.onInstantCashChange}
                onToolTipHover={() => props.onToolTipHover('$250 Cashback')}
                disabled={!props.discountInstantCash250Enabled}
            />
        </TranslationContainer>
    }

    {props.discountInstantCash300Enabled &&
        <TranslationContainer targetProperties={{
            tooltipContent: {
                translationKey: props.discountInstantCash300Enabled ?
                    'catalog-filters-instant-cash-300-tooltip' :
                    'catalog-filters-conditional-option-disabled'
            }
        }}>
            <FilterCheckbox
                name={Filters.DISCOUNT_INSTANT_CASH_300}
                checked={props.discountInstantCash300Value}
                labelTranslationKey={FilterLabelTranslationKeys[Filters.DISCOUNT_INSTANT_CASH_300]}
                tooltipContent="will-be-replace"
                onChange={props.onInstantCashChange}
                onToolTipHover={() => props.onToolTipHover('$300 Cashback')}
                disabled={!props.discountInstantCash300Enabled}
            />
        </TranslationContainer>
    }

    {props.discount5OffEnabled &&
        <TranslationContainer targetProperties={{
            tooltipContent: {
                translationKey: props.discount5OffEnabled ?
                    'catalog-filters-5-percent-off-tooltip' :
                    'catalog-filters-conditional-option-disabled'
            }
        }}>
        <FilterCheckbox
            name={Filters.DISCOUNT_5_OFF}
            checked={props.discount5OffValue}
            labelTranslationKey={FilterLabelTranslationKeys[Filters.DISCOUNT_5_OFF]}
            tooltipContent="will-be-replace"
            onChange={props.onInstantCashChange}
            onToolTipHover={() => props.onToolTipHover('5% Discount')}
            disabled={!props.discount5OffEnabled}
        />
        </TranslationContainer>
    }

    {props.discount10OffEnabled &&
        <TranslationContainer targetProperties={{
            tooltipContent: {
                translationKey: props.discount10OffEnabled ?
                    'catalog-filters-10-percent-off-tooltip' :
                    'catalog-filters-conditional-option-disabled'
            }
        }}>
            <FilterCheckbox
                name={Filters.DISCOUNT_10_OFF}
                checked={props.discount10OffValue}
                labelTranslationKey={FilterLabelTranslationKeys[Filters.DISCOUNT_10_OFF]}
                tooltipContent="will-be-replace"
                onChange={props.onInstantCashChange}
                onToolTipHover={() => props.onToolTipHover('10% Discount')}
                disabled={!props.discount10OffEnabled}
            />
        </TranslationContainer>
    }

    {props.discount15OffEnabled &&
        <TranslationContainer targetProperties={{
            tooltipContent: {
                translationKey: props.discount15OffEnabled ?
                    'catalog-filters-15-percent-off-tooltip' :
                    'catalog-filters-conditional-option-disabled'
            }
        }}>
            <FilterCheckbox
                name={Filters.DISCOUNT_15_OFF}
                checked={props.discount15OffValue}
                labelTranslationKey={FilterLabelTranslationKeys[Filters.DISCOUNT_15_OFF]}
                tooltipContent="will-be-replace"
                onChange={props.onInstantCashChange}
                onToolTipHover={() => props.onToolTipHover('15% Discount')}
                disabled={!props.discount15OffEnabled}
            />
        </TranslationContainer>
    }

    {props.discount20OffEnabled &&
            <TranslationContainer targetProperties={{
                tooltipContent: {
                    translationKey: props.discount20OffEnabled ?
                        'catalog-filters-20-percent-off-tooltip' :
                        'catalog-filters-conditional-option-disabled'
                }
            }}>
                <FilterCheckbox
                    name={Filters.DISCOUNT_20_OFF}
                    checked={props.discount20OffValue}
                    labelTranslationKey={FilterLabelTranslationKeys[Filters.DISCOUNT_20_OFF]}
                    tooltipContent="will-be-replace"
                    onChange={props.onInstantCashChange}
                    onToolTipHover={() => props.onToolTipHover('20% Discount')}
                    disabled={!props.discount20OffEnabled}
                />
            </TranslationContainer>
    }

    {props.discount25OffEnabled &&
        <TranslationContainer targetProperties={{
            tooltipContent: {
                translationKey: props.discount25OffEnabled ?
                    'catalog-filters-25-percent-off-tooltip' :
                    'catalog-filters-conditional-option-disabled'
            }
        }}>
            <FilterCheckbox
                name={Filters.DISCOUNT_25_OFF}
                checked={props.discount25OffValue}
                labelTranslationKey={FilterLabelTranslationKeys[Filters.DISCOUNT_25_OFF]}
                tooltipContent="will-be-replace"
                onChange={props.onInstantCashChange}
                onToolTipHover={() => props.onToolTipHover('25% Discount')}
                disabled={!props.discount25OffEnabled}
            />
        </TranslationContainer>
    }

    {props.promoGiftCard50Enabled &&
        <TranslationContainer targetProperties={{
            tooltipContent: {
                translationKey: props.promoGiftCard50Enabled ?
                    'catalog-filters-promo-gift-card-50-tooltip' :
                    'catalog-filters-conditional-option-disabled'
            }
        }}>
            <FilterCheckbox
                name={Filters.PROMO_GIFT_CARD_50}
                checked={props.promoGiftCard50Value}
                labelTranslationKey={FilterLabelTranslationKeys[Filters.PROMO_GIFT_CARD_50]}
                tooltipContent="will-be-replace"
                onChange={props.onInstantCashChange}
                onToolTipHover={() => props.onToolTipHover('Promo Gift Card $50')}
                disabled={!props.promoGiftCard50Enabled}
            />
        </TranslationContainer>
    }

    {props.promoGiftCard80Enabled &&
        <TranslationContainer targetProperties={{
            tooltipContent: {
                translationKey: props.promoGiftCard80Enabled ?
                    'catalog-filters-promo-gift-card-80-tooltip' :
                    'catalog-filters-conditional-option-disabled'
            }
        }}>
            <FilterCheckbox
                name={Filters.PROMO_GIFT_CARD_80}
                checked={props.promoGiftCard80Value}
                labelTranslationKey={FilterLabelTranslationKeys[Filters.PROMO_GIFT_CARD_80]}
                tooltipContent="will-be-replace"
                onChange={props.onInstantCashChange}
                onToolTipHover={() => props.onToolTipHover('Promo Gift Card $80')}
                disabled={!props.promoGiftCard80Enabled}
            />
        </TranslationContainer>
    }

    {props.promoGiftCard100Enabled &&
        <TranslationContainer targetProperties={{
            tooltipContent: {
                translationKey: props.promoGiftCard100Enabled ?
                    'catalog-filters-promo-gift-card-100-tooltip' :
                    'catalog-filters-conditional-option-disabled'
            }
        }}>
            <FilterCheckbox
                name={Filters.PROMO_GIFT_CARD_100}
                checked={props.promoGiftCard100Value}
                labelTranslationKey={FilterLabelTranslationKeys[Filters.PROMO_GIFT_CARD_100]}
                tooltipContent="will-be-replace"
                onChange={props.onInstantCashChange}
                onToolTipHover={() => props.onToolTipHover('Promo Gift Card $100')}
                disabled={!props.promoGiftCard100Enabled}
            />
        </TranslationContainer>
    }

    {props.promoGiftCard130Enabled &&
        <TranslationContainer targetProperties={{
            tooltipContent: {
                translationKey: props.promoGiftCard130Enabled ?
                    'catalog-filters-promo-gift-card-130-tooltip' :
                    'catalog-filters-conditional-option-disabled'
            }
        }}>
            <FilterCheckbox
                name={Filters.PROMO_GIFT_CARD_130}
                checked={props.promoGiftCard130Value}
                labelTranslationKey={FilterLabelTranslationKeys[Filters.PROMO_GIFT_CARD_130]}
                tooltipContent="will-be-replace"
                onChange={props.onInstantCashChange}
                onToolTipHover={() => props.onToolTipHover('Promo Gift Card $130')}
                disabled={!props.promoGiftCard130Enabled}
            />
        </TranslationContainer>
    }

    {props.promoGiftCard150Enabled &&
        <TranslationContainer targetProperties={{
            tooltipContent: {
                translationKey: props.promoGiftCard150Enabled ?
                    'catalog-filters-promo-gift-card-150-tooltip' :
                    'catalog-filters-conditional-option-disabled'
            }
        }}>
            <FilterCheckbox
                name={Filters.PROMO_GIFT_CARD_150}
                checked={props.promoGiftCard150Value}
                labelTranslationKey={FilterLabelTranslationKeys[Filters.PROMO_GIFT_CARD_150]}
                tooltipContent="will-be-replace"
                onChange={props.onInstantCashChange}
                onToolTipHover={() => props.onToolTipHover('Promo Gift Card $150')}
                disabled={!props.promoGiftCard150Enabled}
            />
        </TranslationContainer>
    }

    {props.promoGiftCard200Enabled &&
        <TranslationContainer targetProperties={{
            tooltipContent: {
                translationKey: props.promoGiftCard200Enabled ?
                    'catalog-filters-promo-gift-card-200-tooltip' :
                    'catalog-filters-conditional-option-disabled'
            }
        }}>
            <FilterCheckbox
                name={Filters.PROMO_GIFT_CARD_200}
                checked={props.promoGiftCard200Value}
                labelTranslationKey={FilterLabelTranslationKeys[Filters.PROMO_GIFT_CARD_200]}
                tooltipContent="will-be-replace"
                onChange={props.onInstantCashChange}
                onToolTipHover={() => props.onToolTipHover('Promo Gift Card $200')}
                disabled={!props.promoGiftCard200Enabled}
            />
        </TranslationContainer>
    }

    {props.promoGiftCard250Enabled &&
        <TranslationContainer targetProperties={{
            tooltipContent: {
                translationKey: props.promoGiftCard250Enabled ?
                    'catalog-filters-promo-gift-card-250-tooltip' :
                    'catalog-filters-conditional-option-disabled'
            }
        }}>
            <FilterCheckbox
                name={Filters.PROMO_GIFT_CARD_250}
                checked={props.promoGiftCard250Value}
                labelTranslationKey={FilterLabelTranslationKeys[Filters.PROMO_GIFT_CARD_250]}
                tooltipContent="will-be-replace"
                onChange={props.onInstantCashChange}
                onToolTipHover={() => props.onToolTipHover('Promo Gift Card $250')}
                disabled={!props.promoGiftCard250Enabled}
            />
        </TranslationContainer>
    }
        </FilterSection>
    );
}

Deals.propTypes = {
    buy4Pay3Enabled: PropTypes.bool.isRequired,
    clearanceEnabled: PropTypes.bool.isRequired,
    instantCashEnabled: PropTypes.bool.isRequired,
    buy4Pay3Value: PropTypes.bool.isRequired,
    clearanceValue: PropTypes.bool.isRequired,
    instantCashValue: PropTypes.bool.isRequired,
    discountInstantCash50Value: PropTypes.bool.isRequired,
    discountInstantCash80Value: PropTypes.bool.isRequired,
    discountInstantCash100Value: PropTypes.bool.isRequired,
    discountInstantCash120Value: PropTypes.bool.isRequired,
    discountInstantCash150Value: PropTypes.bool.isRequired,
    discountInstantCash160Value: PropTypes.bool.isRequired,
    discountInstantCash200Value: PropTypes.bool.isRequired,
    discountInstantCash250Value: PropTypes.bool.isRequired,
    discountInstantCash300Value: PropTypes.bool.isRequired,
    discount5OffValue: PropTypes.bool.isRequired,
    discount10OffValue: PropTypes.bool.isRequired,
    discount15OffValue: PropTypes.bool.isRequired,
    discount20OffValue: PropTypes.bool.isRequired,
    discount25OffValue: PropTypes.bool.isRequired,
    promoGiftCard50Value: PropTypes.bool.isRequired,
    promoGiftCard80Value: PropTypes.bool.isRequired,
    promoGiftCard100Value: PropTypes.bool.isRequired,
    promoGiftCard130Value: PropTypes.bool.isRequired,
    promoGiftCard150Value: PropTypes.bool.isRequired,
    promoGiftCard200Value: PropTypes.bool.isRequired,
    promoGiftCard250Value: PropTypes.bool.isRequired,
    freeFittingValue: PropTypes.bool.isRequired,
    opened: PropTypes.bool.isRequired,
    resettable: PropTypes.bool.isRequired,
    onActionClick: PropTypes.func.isRequired,
    onBuy4Pay3Change: PropTypes.func.isRequired,
    onClearanceChange: PropTypes.func.isRequired,
    onInstantCashChange: PropTypes.func.isRequired,
    onFreeFittingChange: PropTypes.func.isRequired,
    discountInstantCash50Enabled: PropTypes.bool.isRequired,
    discountInstantCash80Enabled: PropTypes.bool.isRequired,
    discountInstantCash100Enabled: PropTypes.bool.isRequired,
    discountInstantCash120Enabled: PropTypes.bool.isRequired,
    discountInstantCash150Enabled: PropTypes.bool.isRequired,
    discountInstantCash160Enabled: PropTypes.bool.isRequired,
    discountInstantCash200Enabled: PropTypes.bool.isRequired,
    discountInstantCash250Enabled: PropTypes.bool.isRequired,
    discountInstantCash300Enabled: PropTypes.bool.isRequired,
    discount5OffEnabled: PropTypes.bool.isRequired,
    discount10OffEnabled: PropTypes.bool.isRequired,
    discount15OffEnabled: PropTypes.bool.isRequired,
    discount20OffEnabled: PropTypes.bool.isRequired,
    discount25OffEnabled: PropTypes.bool.isRequired,
    freeFittingEnabled: PropTypes.bool.isRequired,
    promoGiftCard50Enabled: PropTypes.bool.isRequired,
    promoGiftCard80Enabled: PropTypes.bool.isRequired,
    promoGiftCard100Enabled: PropTypes.bool.isRequired,
    promoGiftCard130Enabled: PropTypes.bool.isRequired,
    promoGiftCard150Enabled: PropTypes.bool.isRequired,
    promoGiftCard200Enabled: PropTypes.bool.isRequired,
    promoGiftCard250Enabled: PropTypes.bool.isRequired,
};

export { Deals };
